import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackPrescriptionPreviewNewClick = (userId?: string): void => {
  trackingService.trackEvent(
    'NEW',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'prescrever',
      step: 'nova prescrição',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPrescriptionPreviewResumeClick = (userId?: string): void => {
  trackingService.trackEvent(
    'RESUME',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'prescrever',
      step: 'retomar prescrição',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
